<template>
  <div id="forgot_body">
    <div id="forgot_full_form">
      <div id="forgot_header">
        <HeaderLogin />
      </div>
      <div id="forgot_content">
        <div id="forgot_form">
          <div v-show="!checkedEmail">
            <div class="forgot_title">
              {{ messages.forgotH[store.langSelect.value] }}
            </div>
            <div id="forgot_text">
              {{ messages.forgotInf[store.langSelect.value] }}
            </div>
            <div
              :class="[
                !loginClass
                  ? 'forgot_form_input el-input'
                  : 'forgot_form_input_error el-input',
              ]"
            >
              <div class="el-input__wrapper">
                <input
                  :placeholder="messages.loginP[store.langSelect.value]"
                  v-model="login"
                  class="el-input__inner"
                />
              </div>
            </div>
            <div style="margin-top: -20px; margin-bottom: 5px; height: 15px">
              <span
                v-if="errLE"
                id="errLogin"
                v-text="messages.loginErr[store.langSelect.value]"
              >
              </span>
            </div>
            <div>
              <div class="forgot_form_input el-input">
                <div class="el-input__wrapper">
                  <input
                    :placeholder="messages.emailP[store.langSelect.value]"
                    class="el-input__inner"
                    v-model="email"
                  />
                </div>
              </div>
            </div>
            <Button
              style="width: 180px"
              @click="sendCheckEmail"
              :text="messages.forgotB[store.langSelect.value]"
            />
          </div>
          <div v-show="checkedEmail">
            <div class="forgot_title">
              {{ messages.forgotH[store.langSelect.value] }}
            </div>
            <div
              :class="[
                !loginClass
                  ? 'forgot_form_input el-input'
                  : 'forgot_form_input_error el-input',
              ]"
            >
              <div class="el-input__wrapper">
                <input
                  :placeholder="messages.codeP[store.langSelect.value]"
                  v-model="code"
                  class="el-input__inner"
                />
              </div>
            </div>
            <el-input
                :placeholder="messages.passwordP[store.langSelect.value]"
                v-model="pass"
                show-password="true"
                :class="[
                  !passClass
                    ? 'forgot_form_input_pass'
                    : 'forgot_form_input_pass_error',
                ]"
              ></el-input>
              <el-input
                :placeholder="messages.passwordPC[store.langSelect.value]"
                v-model="passConfirm"
                show-password="true"
                :class="[
                  !passConfirmClass
                    ? 'forgot_form_input_pass'
                    : 'forgot_form_input_pass_error',
                ]"
              ></el-input>
            <Button
              style="width: 180px"
              @click="sendPassword"
              :text="messages.forgotB[store.langSelect.value]"
            />
          </div>
          <div style="margin-top: 12px; margin-left: 30px"></div>
          <div id="forgot_link_group">
            <router-link to="login"
              >{{ messages.forgotReturnLogin[store.langSelect.value] }}
            </router-link>
          </div>
        </div>
        <div
          id="forgot_img"
          :style="{
            background:
              'url(' +
              store.serverConf[store.currentServer].path +
              '/images/Rectangle24.png)',
          }"
        >
          <svg
            style="position: absolute; top: 30px; right: 30px"
            width="107"
            height="107"
            viewBox="0 0 107 107"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g style="mix-blend-mode: hard-light">
              <circle cx="1.5" cy="1.5" r="1.5" fill="#E9E9E9" />
              <circle cx="1.5" cy="27.5" r="1.5" fill="#E9E9E9" />
              <circle cx="1.5" cy="53.5" r="1.5" fill="#E9E9E9" />
              <circle cx="1.5" cy="105.5" r="1.5" fill="#E9E9E9" />
              <circle cx="27.5" cy="1.5" r="1.5" fill="#E9E9E9" />
              <circle cx="27.5" cy="27.5" r="1.5" fill="#E9E9E9" />
              <circle cx="27.5" cy="53.5" r="1.5" fill="#E82862" />
              <circle cx="27.5" cy="79.5" r="1.5" fill="#E9E9E9" />
              <circle cx="27.5" cy="105.5" r="1.5" fill="#E9E9E9" />
              <circle cx="53.5" cy="1.5" r="1.5" fill="#E9E9E9" />
              <circle cx="53.5" cy="27.5" r="1.5" fill="#E82862" />
              <circle cx="53.5" cy="53.5" r="1.5" fill="#E9E9E9" />
              <circle cx="53.5" cy="79.5" r="1.5" fill="#E82862" />
              <circle cx="53.5" cy="105.5" r="1.5" fill="#E9E9E9" />
              <circle cx="79.5" cy="1.5" r="1.5" fill="#E9E9E9" />
              <circle cx="79.5" cy="27.5" r="1.5" fill="#E9E9E9" />
              <circle cx="79.5" cy="53.5" r="1.5" fill="#E82862" />
              <circle cx="79.5" cy="79.5" r="1.5" fill="#E9E9E9" />
              <circle cx="79.5" cy="105.5" r="1.5" fill="#E9E9E9" />
              <circle cx="105.5" cy="1.5" r="1.5" fill="#E9E9E9" />
              <circle cx="105.5" cy="27.5" r="1.5" fill="#E9E9E9" />
              <circle cx="105.5" cy="53.5" r="1.5" fill="#E9E9E9" />
              <circle cx="105.5" cy="79.5" r="1.5" fill="#E9E9E9" />
              <circle cx="105.5" cy="105.5" r="1.5" fill="#E9E9E9" />
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderLogin from "@/components/HeaderLogin";
import Button from "@/components/Button";
import axios from "axios";
import md5 from "js-md5";
import { useMyStorage } from "@/store/global";
import { useRouter } from "vue-router";
import { ref } from "vue";
//import axios from "axios";
export default {
  components: {
    HeaderLogin,
    Button,
  },
  name: "ForgotPage",
  setup() {
    const messages = {
      forgotH: ["Сбросить пароль", "Forgot your password ?"],
      forgotInf: [
        "Введите адрес электронной почты, указанный при регистрации, и мы вышлем вам код для сброса пароля.",
        "Enter your email and we will send a link to reset your password",
      ],
      loginErr: ["Не верно указаны данные", "Data is incorrect"],
      passwordP: [
        "Пароль (минимум 6 знаков)",
        "Password (at least 6 characters)",
      ],
      passwordPC: ["Повторите пароль", "Confirm password"],
      loginP: [
        "Имя пользователя (минимум 3 знака)",
        "User name (at least 3 characters)",
      ],
      emailP: ["Ваш e-mail", "Email"],
      registerH: ["Новый аккаунт", "NEW REGISTRATION"],
      registerT: [
        "Присоединяйтесь к сообществу опционных трейдеров. Личный кабинет - первый шаг к новым технологиям торговли АЕ.",
        "Join the community of option traders. Registration is the first step towards new AE trading technologies.",
      ],
      passwordC: ["Ещё раз пароль", "Repeat password"],
      enterP: ["Создать", "Enter"],
      footerL: [
        "Уже есть аккаунт? Авторизуйтесь",
        "Already have an account? Log in",
      ],
      codeH: ["Внимание", "ATTENTION"],
      codeT: [
        "На ваш email отправлен код подтверждения. Введите его пожалуйста.\n" +
          '(Если письмо долго не приходит то, проверьте пожалуйста папку "Спам", особенно если у вас mail.ru)',
        "A confirmation code has been sent to your email. Enter the received code.",
      ],
      codeP: ["Код подтверждения", "Code"],
      forgotB: ["Отправить", "Submit"],
      forgotReturnLogin: [
        "Вспомнили пароль? Авторизуйтесь",
        "Return to Sing in >>",
      ],
    };
    const router = useRouter();
    const salt = "$1$ae_salt";
    const checkedEmail = ref(false);
    const store = useMyStorage();
    const login = ref("");
    const loginClass = ref(false);
    const pass = ref("");
    const passClass = ref(false);
    const passConfirm = ref("");
    const passConfirmClass = ref(false);
    const email = ref("");
    const emailClass = ref(false);
    const code = ref("");
    const codeClass = ref(false);
    const errLE = ref(false);
    const Forgot = () => {
      const self = this;

      if (self.viewCode && self.code.length != 6) {
        this.codeClass = true;
        return;
      }
      this.codeClass = false;

      if (this.email.length < 3) {
        this.emailClass = true;
      } else {
        this.emailClass = false;
      }
      if (this.pass.length < 6) {
        this.passClass = true;
      } else {
        this.passClass = false;
      }
      if (this.pass != this.passConfirm) {
        this.passConfirmClass = true;
      } else {
        this.passConfirmClass = false;
      }
      if (
        !this.loginClass &&
        !this.emailClass &&
        !this.passClass &&
        !this.passConfirmClass
      ) {
        if (this.checkingEmail == this.email) {
          this.sendRegistration();
        } else {
          this.sendCheckEmail();
        }
      }
    };
    const sendPassword = () => {
      if (code.value.length < 3) {
        codeClass.value = true;
        return;
      } else {
        codeClass.value = false;
      }
      if (pass.value.length < 6) {
        passClass.value = true;
        return;
      } else {
        passClass.value = false;
      }
      if (pass.value != passConfirm.value) {
        passConfirmClass.value = true;
        return;
      } else {
        passConfirmClass.value = false;
      }
      if (passClass.value == false && passConfirmClass.value == false) {
        const data = {
          login: login.value,
          email: email.value,
          code: code.value,
          pass: md5(pass.value + salt),
        };

        axios
          .post(store.ServerUrl + "/users/setnewpass", data)
          .then(function (response) {
            if (response.data.code === 0) {
              //self.checkingEmail = self.email;
              //self.viewCode = true;
              checkedEmail.value = true;
              console.log("sended");
              router.push("/lk");
            }
            if (response.data.code === 7) {
              //self.checkingEmail = self.email;
              //self.viewCode = true;
              codeClass.value = true;
            }
          });
      }
    };
    const sendCheckEmail = () => {
      const data = {
        login: login.value,
        email: email.value,
      };
      errLE.value = false;
      if (login.value.length < 3 || email.value.length < 3) {
        errLE.value = true;
        return;
      }
      axios
        .post(store.ServerUrl + "/users/checkUser", data)
        .then(function (response) {
          if (response.data.code === 0) {
            //self.checkingEmail = self.email;
            //self.viewCode = true;
            checkedEmail.value = true;
            console.log("sended");
          }
          if (response.data.code === 7) {
            errLE.value = true;
          }
        });
    };
    const sendResetPassword = () => {
      const data = {
        pass: md5(this.pass + salt),
        email: this.email,
        useAuthCode: false,
        passCert: this.programPassword,
        code: this.code,
      };
      axios
        .post(self.store.ServerUrl + "/users/resetPassword", data)
        .then(function (response) {
          if (response.data.code === 0) {
            self.$router.push("/lk");
            //self.autoLink("/lk");
          } else {
            if (response.data.code === 111) {
              self.codeClass = true;
              self.errCode = response.data.msg;
            } else {
              self.viewCode = false;
              self.errLoginHist = self.login;
              self.loginClass = true;
              self.errLogin = response.data.msg;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    };
    const autoLink = (url) => {
      const link = document.createElement("a");
      link.href = url;
      document.body.appendChild(link);
      link.click();
    };

    return {
      store,
      login,
      loginClass,
      pass,
      passClass,
      passConfirm,
      passConfirmClass,
      email,
      emailClass,
      messages,
      checkedEmail,
      code,
      codeClass,
      errLE,
      sendResetPassword,
      Forgot,
      autoLink,
      sendCheckEmail,
      sendPassword,
    };
  },
};
</script>
<style lang="scss">
#forgot_body {
  color: #333;
  //   background-color: #e9e9e9;
  background-color: #222;
  width: 100%;
  height: 100%;
}
#forgot_text {
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #777;
  margin-bottom: 25px;
}
.forgot_form_input {
  // border: 1px solid #c4c4c4;
  padding: 2px 0;
  // height: 20px;
  // width: 291px;
  margin-bottom: 20px;
  background-image: none;
  /* border: none;
   Пароль */
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;
  /* identical to box height */

  /* color: #a5a5a5;*/
}

.forgot_form_input:focus {
  border: 1px solid #222;
  background-image: none;
  outline: none;
}

#forgot_link_group {
  display: flex;
}

#forgot_form a {
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #333;
  text-underline-position: under;
}

#forgot_form a:hover {
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #e82862;
  text-underline-position: under;
}

#forgot_register {
  margin-top: 30px;
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #333;
}

.forgot_form_input_error {
  /* border: 1px solid #c4c4c4; */
  padding: 12px 20px;
  height: 20px;
  width: 291px;
  margin-bottom: 20px;
  background-image: none;
  /* border: none;
   Пароль */
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;
  /* identical to box height */

  /* color: #a5a5a5;*/
  border: 1px solid #e82862;
  background-image: none;
  outline: none;
}

#errLogin,
#errPass {
  color: #e82862;
}
.forgot_form_input_pass,
.forgot_form_input_pass_error {
  height: 44px;
  margin-bottom: 20px;
}

.forgot_form .el-input__wrapper {
  border-radius: 0 !important;
  border: 1px solid #c4c4c4;
  box-shadow: none;
  padding: 12px 20px;
  color: #a5a5a5 !important;
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;
}
.forgot_form_input_pass_error .el-input__wrapper {
  border-radius: 0;
  border: 1px solid #e82862;
  box-shadow: none;
  padding: 12px 20px;
  color: #a5a5a5 !important;
  font-family: Roboto Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;
}
.el-input__wrapper {
  border-radius: 0 !important;
  border: 1px solid #c4c4c4;
  box-shadow: none;
}
.is-focus .el-input__wrapper.is-focus {
  border: 1px solid #222;
  box-shadow: none;
}
.el-input__wrapper.is-focus {
  border: 1px solid #222;
  box-shadow: none !important;
}
.el-select .el-input__wrapper.is-focus {
  border: 1px solid #222;
  box-shadow: none !important;
}
.el-input__wrapper input::placeholder {
  color: #6c6c6c;
}
.forgot_form_input_pass .el-input__wrapper input {
  color: #222;
}
.forgot_form_input .el-input__wrapper input {
  border: none;
  color: #222;
}
@media (max-height: 520px) {
  #full_login_form {
    top: 0 !important;
    transform: translate(-50%, 0) !important;
  }
}
@media (min-width: 750px) {
  #forgot_full_form {
    width: 749px;
    height: 525px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    #forgot_header {
      width: 749px;
      height: 141px;
    }

    #forgot_content {
      width: 749px;
      height: 384px;
      box-shadow: 0 12px 20px rgba(0, 0, 0, 0.06);
      display: flex;
      border-radius: 0 0 40px;
      #forgot_form {
        width: 331px;
        height: 264px;
        background-color: white;
        padding: 30px 60px;

        .forgot_title {
          margin-bottom: 20px;
          font-family: Proxima Nova Condensed;
          font-style: normal;
          /* font-weight: 600;*/
          font-size: 20px;
          line-height: 24px;
          text-transform: uppercase;
          color: #222222;
        }
      }
    }
    #forgot_img {
      position: relative;
      width: 298px;
      height: 384px;
      /*background-size: 47px 31px;*/
      /*background: url('/lk/images/Rectangle24.png');*/
    }
  }
}

@media (max-width: 750px) {
  .el-dialog {
    width: 100% !important;
  }
  #forgot_full_form {
    width: 100%;
    height: 525px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    #forgot_header {
      width: 100%;
      height: 141px;
      //  overflow: hidden;
    }

    #forgot_content {
      width: 100%;
      height: 384px;
      box-shadow: 0 12px 20px rgba(0, 0, 0, 0.06);
      display: flex;

      #forgot_form {
        width: 100%;
        height: 264px;
        background-color: white;
        padding: 30px 10px;

        .forgot_title {
          margin-bottom: 20px;
          font-family: Proxima Nova Condensed;
          font-style: normal;
          /* font-weight: 600;*/
          font-size: 20px;
          line-height: 24px;
          text-transform: uppercase;
          color: #222222;
        }
      }
      #forgot_img {
        display: none;
        /*background-size: 47px 31px;*/
        /*background: url('/lk/images/Rectangle24.png');*/
      }
    }
  }
}
</style>
